// 分页组件，每页显示数量.
export const pageSizes = [10, 20, 50]
export const pageSize = 20
